(function(){
  document.addEventListener("DOMContentLoaded", function () {
    
    (function($){
      var $slider = $('.related-grid');
      var $dots = $('.related-dot');

      $slider.slick({
          dots: true,
          arrows: true,  
          prevArrow: $('.custom-prev'),
        nextArrow: $('.custom-next'),
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 640, settings: { slidesToShow: 1 } }
          ]
        });

        // When slide changes, update active dot
      $slider.on('afterChange', function(event, slick, currentSlide) {
        $dots.removeClass('active');
        $dots.eq(currentSlide).addClass('active');
      });

      // When a dot is clicked, go to that slide
      $dots.on('click', function() {
        var index = $(this).index();
        $slider.slick('slickGoTo', index);
      });
      
  })(jQuery);

  });
})();
